import { AddressDTO } from "./addressDTO";

export class CustomerDTO{
    public id!:number;
    public name!:string;
    public addressList!: AddressDTO[];
    public premierPartnerIdList!: number[];
    public deleted!:boolean;
    public canCreateMoovs!:boolean;
    public billingCustomerId?:string;
    public added?:string;
    public detamoovEmailAddress?:string;
    public tag?:string; //json {"integrations": [{"name":"a", "id":1},{"name":"b", "id":2},{"name":"c", "id":3}], "otherTag": "value"}

    constructor(){
        this.addressList = new Array();
        this.premierPartnerIdList = new Array();
    }
}